import { __decorate, __metadata } from "tslib";
import { injectable } from '@/inversify.config';
let Service = class Service {
    constructor() {
        this.subscriptions = new Set();
        this.services = new Set();
    }
    static { this.injectMixin = {
        beforeCreate() {
            this.serviceInjectMixin_services = new Set();
        },
        beforeDestroy() {
            this.serviceInjectMixin_services.forEach(function (service) {
                if (service && service.destroy) {
                    service.destroy();
                }
            });
        },
    }; }
    destroy() {
        this.services.forEach(function (service) {
            if (service && service.destroy) {
                service.destroy();
            }
        });
        this.subscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
    }
};
Service = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], Service);
export default Service;
